
import { getDay, format } from 'date-fns';
import { TeacherAvailabilityException, WeeklySchedule } from '@/types/teacherAvailability';

export function getDateAvailability(
  date: Date,
  weeklySchedule: WeeklySchedule,
  exceptions: TeacherAvailabilityException[]
) {
  const dayOfWeek = getDay(date) === 0 ? 7 : getDay(date); // Convert Sunday (0) to 7 for our system
  const dateStr = format(date, 'yyyy-MM-dd');
  
  // Check if there's an exception for this date
  const exception = exceptions.find(ex => ex.exception_date === dateStr);
  if (exception) {
    return {
      status: 'exception' as const,
      type: exception.exception_type,
      timeSlots: exception.exception_type === 'PARTIAL_UNAVAILABLE' 
        ? [`${exception.start_time} - ${exception.end_time}`] 
        : [],
      reason: exception.reason,
      basicTimeSlots: weeklySchedule[dayOfWeek] || []
    };
  }

  // Check if there are regular time slots for this day
  const daySlots = weeklySchedule[dayOfWeek] || [];
  if (daySlots.length > 0) {
    return {
      status: 'available' as const,
      timeSlots: daySlots.map(slot => `${slot.start_time} - ${slot.end_time}`),
      basicTimeSlots: daySlots
    };
  }

  return { 
    status: 'unavailable' as const, 
    timeSlots: [],
    basicTimeSlots: []
  };
}
